export interface Company {
  id: number;
  name: string;
}

export const PAGE_SIZE = 10;

export const SECTIONS = [
  {
    name: "facilities",
    icon: "warehouse",
    href: "/facilities",
  },
  {
    name: "vehicles",
    icon: "car",
    href: "/vehicles",
  },
];

export const UNITS = [
  { value: "kg", label: "Kilogramos" },
  { value: "km", label: "Kilómetros" },
  { value: "kWh", label: "Kilowatios Hora" },
  { value: "L", label: "Litros" },
  { value: "m3", label: "Metros Cúbicos" },
  { value: "mi", label: "Millas" },
];
